const PageLayout = ({ children }) => {
  return <div className='full-content'>{children}</div>;
};

export default PageLayout;
